import React from "react";

const EqualToSign = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M15 7.5C15 8.9834 14.5601 10.4335 13.736 11.6669C12.9118 12.9003 11.7404 13.8616 10.3699 14.4292C8.99941 14.9968 7.49136 15.1453 6.03648 14.8558C4.58159 14.5663 3.24522 13.8519 2.19637 12.803C1.14751 11.754 0.43328 10.4175 0.143998 8.96259C-0.145284 7.50767 0.00337633 5.99965 0.571179 4.62922C1.13898 3.25879 2.10042 2.08751 3.33391 1.26352C4.56741 0.439521 6.01755 -0.000187309 7.50095 5.98564e-08C8.48582 5.1998e-08 9.46104 0.194 10.3709 0.570922C11.2808 0.947844 12.1075 1.5003 12.8039 2.19676C13.5003 2.89321 14.0526 3.72001 14.4294 4.62994C14.8062 5.53988 15.0001 6.51513 15 7.5ZM12.1978 5.33062C12.1978 5.13163 12.1188 4.94079 11.978 4.80009C11.8373 4.65938 11.6465 4.58033 11.4475 4.58033H3.54112C3.34213 4.58033 3.15129 4.65938 3.01059 4.80009C2.86988 4.94079 2.79083 5.13163 2.79083 5.33062C2.79083 5.5296 2.86988 5.72044 3.01059 5.86115C3.15129 6.00185 3.34213 6.0809 3.54112 6.0809H11.4475C11.6465 6.0809 11.8373 6.00185 11.978 5.86115C12.1188 5.72044 12.1978 5.5296 12.1978 5.33062ZM12.1978 9.69211C12.1976 9.49329 12.1184 9.3027 11.9777 9.1622C11.837 9.0217 11.6463 8.94278 11.4475 8.94278H3.54112C3.34687 8.94968 3.16288 9.0317 3.0279 9.17157C2.89292 9.31143 2.81749 9.49822 2.81749 9.69259C2.81749 9.88696 2.89292 10.0737 3.0279 10.2136C3.16288 10.3535 3.34687 10.4355 3.54112 10.4424H11.4475C11.6465 10.4424 11.8373 10.3634 11.978 10.2226C12.1188 10.0819 12.1978 9.8911 12.1978 9.69211Z"
        fill="black"
      />
    </svg>
  );
};

export default EqualToSign;
